"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLPTokenPrice = void 0;
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var launchpadConstants_1 = require("../../launchpadConstants");
var utils_1 = require("../../shared/utils");
/**
 * To determine the price of an LP token we need: totalValueInUsd / totalSupply
 * - total supply from pairContract.totalSupply
 * - totalValueInUsd:
 *  - token (TPAD) price in USD * reserve 1
 *  - PLUS pair token (BNB) price in USD * reserve 2
 */
function useLPTokenPrice(_a) {
    var pairContract = _a.pairContract, tokenPriceInUsd = _a.tokenPriceInUsd, currencyPriceInUsd = _a.currencyPriceInUsd, tokenDecimals = _a.tokenDecimals, _b = _a.intervalSec, intervalSec = _b === void 0 ? 300 : _b;
    var _c = (0, react_1.useState)(0), price = _c[0], setPrice = _c[1];
    var getLPPrice = (0, react_1.useCallback)(function (tokensBN, currencyBN, supplyBN) {
        var tokensValue = tokensBN.muln(tokenPriceInUsd);
        var currencyValue = currencyBN.muln(currencyPriceInUsd);
        var totalValue = tokensValue.add(currencyValue);
        var price = totalValue.mul(launchpadConstants_1.DEC_NORM).div(supplyBN);
        // debug("useLPTokenPrice.getLPPrice", {
        //   // @ts-expect-error
        //   address: pairContract._address,
        //   tokenPriceInUsd,
        //   currencyPriceInUsd,
        //   tokens: toEth(tokensBN),
        //   currency: toEth(currencyBN),
        //   supply: toEth(supplyBN),
        //   tokensValue: toEth(tokensValue),
        //   currencyValue: toEth(currencyValue),
        //   totalValue: toEth(totalValue),
        //   price: toEth(price),
        // });
        return (0, utils_1.toEthN)(price);
    }, [tokenPriceInUsd, currencyPriceInUsd, pairContract]);
    (0, react_1.useEffect)(function () {
        if (!pairContract)
            return;
        var update = function () {
            Promise.all([
                (0, utils_1.call)(pairContract, "getReserves"),
                (0, utils_1.call)(pairContract, "totalSupply"),
            ])
                .then(function (_a) {
                var reserves = _a[0], totalSupply = _a[1];
                var tokensBN = (0, utils_1.normalizeDecimals)((0, web3_utils_1.toBN)(reserves["_reserve0"]), tokenDecimals);
                var currencyBN = (0, web3_utils_1.toBN)(reserves["_reserve1"]);
                var supplyBN = (0, web3_utils_1.toBN)(totalSupply);
                var price = getLPPrice(tokensBN, currencyBN, supplyBN);
                setPrice(price);
            })
                .catch(function (e) { return console.error("Failed to determine LP Token price", e); });
        };
        update();
        var id = setInterval(update, intervalSec * 1000);
        return function () { return clearInterval(id); };
    }, [pairContract, getLPPrice]);
    return price;
}
exports.useLPTokenPrice = useLPTokenPrice;
